<template>
  <div class="content">{{message}}</div>
</template>
<script>
export default {
  data() {
    return {
      message: null
    };
  }
};
</script>
<style lang="less" scoped>
.content {
  position: fixed;
  display: inline-block;
  padding: 5px 8px;
  color: #fff;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  max-width: 300px;
  word-break: break-all;
  white-space: pre-wrap;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/component.vue